import React, { useEffect, useRef, useState } from "react";
import TakeActionStepOne from "./TakeActionStepOne";
import TakeActionStepTwo from "./TakeActionStepTwo";
import TakeActionStepThree from "./TakeActionStepThree";
import TakeActionStepFour from "./TakeActionStepFour";
import { useSearchParams } from "react-router-dom";

const TakeActionForm = ({ data }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [step, setStep] = useState(searchParams.get("step") || 1);
  const [stepOneFormData, setStepOneFormData] = useState("");
  const [formData, setFormData] = useState({});
  const stepFourRef = useRef(null);
  const urlStep = Number(searchParams.get("step"));

  useEffect(() => {
    if (urlStep === 4) {
      setStep(urlStep);
    } else {
      setStep(1);
    }
  }, []);
  useEffect(() => {
    if (step === 4) {
      setSearchParams({ step: "4" });
      setTimeout(() => {
        const element = stepFourRef.current;
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            window.scrollBy({ top: 410, behavior: "smooth" });
          }, 300);
        }
      }, 100);
    } else {
      setSearchParams({});
    }
  }, [step]);

 const backHandler = () => {
  if (step > 1) {
    setStep((prev) => prev - 1);
  }
};
  const stepComponents = {
    1: (
      <TakeActionStepOne
        setStep={setStep}
        stepOneFormData={stepOneFormData}
        setStepOneFormData={setStepOneFormData}
        data={data}
      />
    ),
    2: (
      <TakeActionStepTwo
        setStep={setStep}
        formData={formData}
        setFormData={setFormData}
        backHandler={backHandler}
        data={data}
      />
    ),
    3: (
      <TakeActionStepThree
        setStep={setStep}
        stepOneFormData={stepOneFormData}
        formData={formData}
        backHandler={backHandler}
      />
    ),
    4: (
      <div className="-mt-10" ref={stepFourRef}>
        <TakeActionStepFour ref={stepFourRef} />
      </div>
    ),
  };

  return <>{stepComponents[step]}</>;
};

export default TakeActionForm;
